import { Editor_Words } from "@/utils/lang/editor";
import { FlexProps, LayoutProps } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { Categories, WordEntityTypeWithParentKeys, WordNameDictionary } from "./type";
/**
 * 关键词效果容器
 */
export const WordTableContext = React.createContext<{
  onSelect: (word: WordEntityTypeWithParentKeys) => void;
  tablePopupProps?: FlexProps;
  nameDict: WordNameDictionary;
  tableTitle?: Editor_Words;
  searchPlaceholder?: Editor_Words;
  defaultCate?: Categories;
  category?: Categories;
  onCategoryChange?: (cate: Categories) => void;
  checkValueFn?: (item: WordEntityTypeWithParentKeys) => boolean;
  tableRightSide?: ReactNode;
  TableItemRender?: React.FunctionComponent<{
    data: WordEntityTypeWithParentKeys;
  }>;
  keywordListConfig?: {
    containerWidth?: LayoutProps["w"];
    containerMaxHeight?: LayoutProps["h"];
    containerMaxWidth?: LayoutProps["maxW"];
    columnCount?: number;
  };
  searchFilter?: (
    list: WordEntityTypeWithParentKeys[],
    names: WordNameDictionary,
  ) => (value?: string) => WordEntityTypeWithParentKeys[];
}>({ onSelect: () => void 0, nameDict: {}, category: "people" });
